const RateLimit = () => {
	return (
		<div>
			We have hit the NYT API Rate limit. Please wait 1 minute...
		</div>
	)
}

export default RateLimit;